<template>
    <div class="orderItems">
        <div class="accordion" role="tablist">
            <template v-for="(order) in orderlist">
                <b-card 
                    v-if="filtered.includes(order.assign_to.id) && filteredstatus.includes(order.order.status)"
                    :key="order.order.id" 
                    no-body 
                    class="mb-1">
                    <b-card-header
                        header-tag="header"
                        :class="[order.order.status]"
                        role="tab"
                    >
                        <div v-b-toggle="`orderItem-${order.order.id}`" class="orderItem">
                            <b-row no-gutters>
                                <b-col cols="11">
                                    <div class="orderDetails">
                                        <div class="deliveryInfo">
                                            <div
                                                class="deliveryInfoItem deliveryUser"
                                            >   
                                                <template v-if="order.assign_to.avatar">
                                                    <div
                                                        :style="`background-image : url(${order.assign_to.avatar});`"
                                                        class="deliveryImage"
                                                    ></div>
                                                </template>

                                                <template v-else>
                                                     <div
                                                        class="deliveryImage">

                                                        <b-icon icon="person"></b-icon>
                                                    </div>
                                                </template>
                                            </div>

                                            <div
                                                class="deliveryInfoItem orderSize"
                                            >
                                                <span class="numberOrder">
                                                    {{order.order.numberofboxes}}
                                                </span>
                                                <span class="doz">
                                                    DOZ
                                                </span>
                                            </div>
                                        </div>

                                        <div class="orderName">
                                            <h4>{{order.order.contact_name}}</h4>
                                            <p>
                                                <b-icon
                                                    icon="calendar"
                                                ></b-icon>
                                                {{order.order.order_event_time_range ? `${order.order.order_event_time_range}, ` : ''}} {{order.order.delivery_date | formatdate('MMM D')}}
                                            </p>
                                            <p>
                                                <b-icon
                                                    icon="filter-left"
                                                ></b-icon>
                                                {{order.order.order_event_time_range ? `Event` : 'Subscription'}}
                                            </p>
                                        </div>
                                    </div>
                                </b-col>

                                <b-col cols="1">
                                    <span class="collapseIcon">
                                        <b-icon icon="chevron-up"> </b-icon>
                                        <b-icon icon="chevron-down"> </b-icon>
                                    </span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card-header>

                    <b-collapse
                        :id="`orderItem-${order.order.id}`"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="orderTrail">
                                <div class="orderTrailItem">
                                    <span class="trailType done">
                                        <b-icon
                                            icon="file-earmark-text-fill"
                                        ></b-icon>
                                    </span>

                                    <div class="trailDetails">
                                        <h4>Order created</h4>
                                        <p>{{order.order.created_at | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                    </div>
                                </div>

                                <div class="orderTrailItem">
                                    <span class="trailType done">
                                        <b-icon icon="person-fill"></b-icon>
                                    </span>

                                    <div class="trailDetails">
                                        <h4>Assigned to {{order.assign_to.name}}</h4>
                                        <p>{{order.created_at | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                    </div>

                                    <div 
                                        @click="removeassignment(order)"
                                        class="trailAction" 
                                        v-if="order.order.status == 'assign'">
                                        <button 
                                            :disabled="processing"
                                            class="btn btn-outline-primary">
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                                <div class="orderTrailItem">
                                    <span 
                                        :class="[`trailType`, {'done' : order.order.status != 'assign'}]">
                                        <b-icon icon="check"></b-icon>
                                    </span>

                                    <div 
                                        :class="[`trailDetails orderstatus`]">
                                        <h4>Accepted</h4>
                                        <template v-if="order.order.status != 'assign'">
                                            <p>{{accepteddate(order) | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                        </template>

                                        <template v-else>
                                            <p>Pending</p>
                                        </template>
                                    </div>
                                </div>

                                <template v-for="(amend, index) in amendstatuses(order.order)">
                                      <div :key="index" class="orderTrailItem amendstatuses">
                                        <span 
                                            :class="[`trailType`, 'done']">
                                            <b-icon icon="pen-fill"></b-icon>
                                        </span>

                                        <div 
                                            :class="[`trailDetails orderstatus`]">
                                            <h4>Amended</h4>
                                            <p class="mb-0">{{amend.created_at | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                            <p>{{amend.notes}}</p>
                                        </div>
                                    </div>

                                </template>

                                <div class="orderTrailItem">
                                    <span 
                                        :class="[`trailType`, {'done' : order.order.status == 'delivered'}]">
                                        <b-icon icon="box-seam"></b-icon>
                                    </span>

                                    <div class="trailDetails">
                                        <h4>Delivered</h4>

                                        <template v-if="order.order.status == 'delivered'">
                                            <p>{{delivereddate(order) | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                        </template>

                                        <template v-else>
                                            <p>ETA {{order.order.order_event_time_range ? `${order.order.order_event_time_range}, ` : ''}} {{order.order.delivery_date | formatdate('MMM D')}}</p>
                                        </template>
                                    </div>
                                </div>

                                <div class="orderDelivered" v-if="order.order.status == 'delivered'">
                                    <div class="deliveredAction">
                                        <button 
                                            v-if="checkiftoday(order)"
                                            @click="$emit('update:amend', order), $bvModal.show('amendorder')"
                                            class="btn btn-outline-primary">
                                            Amend
                                        </button>

                                        <button 
                                            @click="confirmorder(order)"
                                            class="btn btn-primary">
                                            CONFIRM
                                        </button>
                                    </div>

                                    <div class="deliveryProof">
                                        <img
                                            :src="getdeliverimg(order)"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="orderContactDetails">
                                <div class="contactItem">
                                    <b-icon icon="telephone-fill"></b-icon>
                                    {{order.order.phone_number | VMask('(###) ###-####')}}
                                </div>

                                <div class="contactItem">
                                    <b-icon icon="calendar"></b-icon> {{order.order.order_event_time_range ? `${order.order.order_event_time_range}, ` : ''}} {{order.order.delivery_date | formatdate('MMM D')}}
                                </div>

                                <div class="contactItem">
                                    <b-icon icon="geo-alt"></b-icon> {{order.order.shipping_address_street}} {{order.order.shipping_address_city}} {{order.order.shipping_address_state}} {{order.order.shipping_address_zipcode}}
                                </div>

                                <div class="contactItem">
                                    <div class="orderNote">
                                        {{order.order.order_notes ? order.order.order_notes : 'No notes'}}
                                    </div>
                                </div>
                            </div>

                            <div class="orderSummary">
                                <div class="orderSummaryHeader">
                                    <b-row>
                                        <b-col cols="9">
                                            <h4>Order {{order.order.order_number}} summary</h4>
                                        </b-col>

                                        <b-col cols="3 dozen">
                                            {{order.order.numberofboxes}} Dozen
                                        </b-col>
                                    </b-row>
                                </div>

                                <div class="orderBreakdown">
                                    <template v-for="(box, index) in grouporderbox(order.order.orderboxitems)">

                                        <div :key="index" class="orderBreakdownItem">
                                            <div 
                                                @click="expandflavor = expandflavor == index ? null : index"
                                                class="orderboxheader">
                                                <span class="orderNumber">{{box.count}}</span> -
                                                <span class="boxname">{{box.box_name}} </span>
                                                <span class="expand">
                                                    <template v-if="expandflavor == index">
                                                        <b-icon icon="chevron-up"></b-icon>
                                                    </template>

                                                    <template v-else>
                                                        <b-icon icon="chevron-down"></b-icon>
                                                    </template>
                                                </span>
                                            </div>

                                            <div 
                                                v-if="expandflavor == index"
                                                class="flavorlist">

                                                <template v-for="(flavor, index) in groupflavors(box.flavors)">
                                                    <div :key="index" class="flavorname">
                                                        {{flavor.name}}
                                                    </div>
                                                </template>

                                            </div>
                                        </div>
                                    </template>

                                </div>
                            </div>

                            
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </template>
        </div>
    </div>
</template>

<script>

/**
 * Declerations
 */
// plugins
import axios from 'axios'
import moment from 'moment'

// helper
import Helper from '@/helpers/helper'

// mixins
import {orderboxmixins} from "@/mixins/orderboxmixins"

export default {
    mixins : [orderboxmixins],
    props : {
        amend : {
            type : Object,
            default : () => null
        },
        orderlist : {
            type : Array,
            default : () => []
        },
        filteredstatus : {
            type : Array,
            default : () => []
        },
        filtered : {
            type : Array,
            default : () => []
        }
    },
    data() {
        return {
            expandedbox    : null,
            orderboxgroup  : [],
            expandflavor   : null,
            confirmingorder: null,
            processing : false
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : ''
        },
        /**
         * Force format date by
         * @param format
         */
        forceformatdate(date, format) {
            return date ? Helper.formatdate(date, format, true) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        }
    },
    methods : {
        /**
         * Get amend statuses
         * 
         */
        amendstatuses(order) {
            let amendlist =  order.orderstatuses.filter(s => s.status.match(/amend/i));

            return amendlist.slice().sort((a, b) => new Date(a.updated_at) - new Date(b.updated_at))
        },
        /**
         * Check if delivered today
         * then show amend button only when it delivered today
         */
        checkiftoday(order) {
            const deliverydate = this.delivereddate(order)

            return deliverydate ? moment(deliverydate).isSame(moment(), 'day') : false
        },
        /**
         * confirm order
         */
        async confirmorder(order) {
            this.$emit('removeassign', order.order_id)

            const url = `/update_order_status/${order.order_id}`
            await axios.post(url, {
                status: 'confirm',
            })
        },
        /**
         * Get delivery proof
         */
        getdeliverimg(order) {
            if(order.order.status == 'delivered') {
                const status = order.order.orderstatuses.find(s => s.status == 'delivered');
                console.log('deliveryimage', status)


                return status ? status.status_image : ''
            } else {
                return ''
            }
        },
        /**
         * Cancel order assignment
         */
        async removeassignment(order) {
                  this.processing = true
            const url             = `/unassign_order/${order.order.id}`
            await axios.post(url, {assign_to : order.assign_to.id}).catch(err => console.log(err)) 
            this.processing = false
            this.$emit('removeassign', order.order.id)
        },
        /**
         * Get accepted date
         */
        accepteddate(order) {
            const status = order.order.orderstatuses.find(s => s.status == 'accepted');

            return status ? status.created_at : ''
        },
        /**
         * Get delivered date
         */
        delivereddate(order) {
            const status = order.order.orderstatuses.find(s => s.status == 'delivered');

            return status ? status.created_at : ''
        },
        /**
         * Check order status
         * 
         */
        checkdeliverystatus(order) {
            const [status] =  order.order.orderstatuses

            return status ? status.status : ''
        },
        /**
         * Group same flavors
         */
        groupflavors(flavors) {
            return flavors.filter((value, index, self) => index == self.findIndex(t => t.flavor_id == value.flavor_id));
        },
        /**
         * Group order boxes and flavors
         */
        grouporderbox(orders) {
            const orderlist = Object.values(orders)

            const group = this.groupboxorder(orderlist)

            return group
        }
    },
    /**
     * Run functions after component rendered
     */
    mounted () {
        
    }
}
</script>

<style lang="scss">
@import '@/scss/partials/_colors.scss';

.orderItems {

    .deliveryImage {
        svg {
            border-radius: 100%;
            width        : 100%;
            height       : 100%;
            border       : 1px solid $grey;
            padding      : 15px;
        }
    }

    .orderTrail {

        .orderstatus {
            p {
                text-transform: capitalize;
            }
        }
    }

    .card {
        p {
            font-size : 13px;
        }

        h4  {
            font-size : 18px;
        }

        header {
            padding-left : 15px;
            padding-right: 0;
        }

    }


    .orderBreakdown {
        .orderBreakdownItem {
            cursor     : pointer;
            
            .orderboxheader {
                display    : flex;
                align-items: center;
    
                .b-icon.bi {
                    font-size : 12px;
                }
    
                .orderNumber {
                    margin-right : 10px;
                }
    
                .boxname {
                    margin-left : 10px;
                    font-weight : 600;
                    margin-right: 10px;
                }
            }

            .flavorlist {
                padding-left : 30px;

                .flavorname {
                    &::before {
                        content     : '●';
                        margin-right: 10px;
                    }
                }

            }
        }

    }
}

</style>
